<div class="filter-container">
    <button [matMenuTriggerFor]="filtersMenu" [ngClass]="isSearch ? 'active': ''">
        <div class="filters-count" *ngIf="isSearch"><span>{{filtersCount}}</span></div>
        <div class="label">
            <app-svg-icon [icon]="icon"></app-svg-icon>
            <span *ngIf="label">{{label}}</span>
        </div>
    </button>
    <mat-menu #filtersMenu class="filters-menu-panel" >
      <form [formGroup]="form">
        <div (click)="clickMenu($event)">
            <!-- menu header -->
            <div class="header">
                <p class="title">{{'BUTTONS.FILTERS' | translate}}</p>
                <input class="reset" type="button" [value]="'BUTTONS.RESET' | translate" (click)="onReset()" [disabled]="disableResetButton  || (form.value | isObjectHasValues)">
            </div>
            <mat-divider></mat-divider>
            <!-- content -->
            <div class="content">
                <ng-content></ng-content>
            </div>
            <!-- search button -->
            <ng-container *ngIf="showSearchButton">
                <app-shared-button-component
                    [buttonName]="'BUTTONS.APPLY' | translate"
                    [caller]="onClickSearchButton()"
                    [disableButton]="form.invalid">
                </app-shared-button-component>
            </ng-container>
        </div>
      </form>
    </mat-menu>
</div>